export default "__VITE_ASSET__CBoIkdCI__"